import CodeError from './CodeError';

class AccountAlreadyExistsError extends CodeError {
  constructor() {
    const code = 'accountAlreadyExists';
    const message = 'Account already exists';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default AccountAlreadyExistsError;
